/* Site-Specific JavaScript */

function calculateLeftSpacing() {
    var element = document.querySelector('.module-text-block--video .container');
    if (element) {
        var rect = element.getBoundingClientRect();
        var leftSpacing = rect.left;
        var modules = document.querySelectorAll('.match-left-spacing .container-fluid');
        
        modules.forEach(element => {
            element.style.paddingLeft = `${rect.left}px`;
        });    
    }
}

// Run the function once to get the initial value
calculateLeftSpacing();

// Add event listener for window resize
window.addEventListener('resize', calculateLeftSpacing);

//Video Play/Pause Buttons
    var playBars = document.querySelectorAll('.playbar');
    playBars.forEach(function(el) {
        // get video id from attribute 'data-target'
        var targetVideo = document.getElementById(el.dataset.target);
        var playBtn = el.querySelectorAll('.play-btn');
        var pauseBtn = el.querySelectorAll('.pause-btn');
        if (targetVideo) {
          //Controls don't show by default to match designs
          //On play, we hide the designed playbar and show the native controls.
          //Autoplaying background videos are exempt - their playbar is the
          //WCAG 2.2.2 pause control and has to stay put.
          if (!targetVideo.autoplay) {
            targetVideo.addEventListener('play', function() {
              el.classList.add('hide');
              targetVideo.setAttribute('controls', '');
            });
          }
          jq(playBtn).click(function(e) {
            if (targetVideo.paused) {
              targetVideo.play();
              jq(this).attr('aria-pressed', 'true');
              jq(pauseBtn).attr('aria-pressed', 'false');
              targetVideo.focus();
            }
            if (el.classList.contains('paused')) {
                el.classList.toggle('paused');    
            }
            if (!el.classList.contains('playing')) {
                el.classList.toggle('playing');    
            }
          });
          jq(pauseBtn).click(function(e) {
            if (!targetVideo.paused) {
              targetVideo.pause();
              jq(playBtn).attr('aria-pressed', 'false');
              jq(this).attr('aria-pressed', 'true');
            }
            if (!el.classList.contains('paused')) {
                el.classList.toggle('paused');    
            }
            if (el.classList.contains('playing')) {
                el.classList.toggle('playing');    
            }
          });
        }
    });

jq(document).ready(function() {
  // Existing script
  jq('.timeline-tabbed-content .nav-tabs .nav-link').click(function(e) {
    e.preventDefault();

    var targetId = jq(this).data('target');
    var $targetPane = jq(targetId);
    var $scrollableContainer = jq('.tab-content');

    if ($targetPane.length && $scrollableContainer.length) {
      // Calculate the position of the target pane relative to the scrollable container
      var paneTopPosition = $targetPane.position().top + $scrollableContainer.scrollTop();
      var scrollableHeight = $scrollableContainer.height();
      var contentHeight = $scrollableContainer.prop('scrollHeight');

      // Calculate the maximum scroll position to avoid blank space at the bottom
      var maxScrollPosition = contentHeight - scrollableHeight;

      // If the desired scroll position is greater than the maximum, use the maximum
      if (paneTopPosition > maxScrollPosition) {
        paneTopPosition = maxScrollPosition;
      }

      $scrollableContainer.animate({
        scrollTop: paneTopPosition
      }, 'slow');
    }
  });


  // Custom keyboard controls
  const $sideNav = jq('.timeline-tabbed-content .nav-tabs');
  const $navItems = $sideNav.find('.nav-link');
  const $sections = jq('.year-item, .sub-year-item, .timeline-tabbed-content .tab-pane').attr('tabindex', '0');
  let currentNavIndex = 0;

  const focusSection = (index) => {
    const targetSectionId = $navItems.eq(index).data('target');
    jq(`${targetSectionId}`).focus();
  };

  const focusNavItem = (index) => {
    $navItems.eq(index).focus();
  };

  $sections.on('keydown', function(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      focusNavItem(currentNavIndex);
    }
  });
  
    $sections.on('keydown', function(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      focusNavItem(currentNavIndex);
    }
  });
  
  $navItems.on('click', function(e) {
    e.preventDefault();
    currentNavIndex = $navItems.index(this);
    jq(this).trigger('keydown', { shiftKey: true, key: 'Enter' });
  });

  $navItems.on('keydown', function(event) {
   if (!jq(this).hasClass('parent')) {
    if (event.key === 'Enter') {
      event.preventDefault();
      currentNavIndex = $navItems.index(this);
      focusSection(currentNavIndex);
    }
   }
  });
});


// IDEA Image Slideshow Slider
if (jq(".featured-slider").length) {
    jq(".featured-slider").on("afterChange", function(event, slick, currentSlide){
        jq(".slider-thumbnails").slick("slickGoTo", currentSlide);
        var currentNavSlideElem = ".slider-thumbnails .slick-slide[data-slick-index='" + currentSlide + "']";
        jq(".slider-thumbnails .slick-slide.is-active").removeClass("is-active");
        jq(currentNavSlideElem).addClass("is-active");
    });

    function goToSlide(element) {
        var goToSingleSlide = jq(element).data("slick-index");
        jq(".slider-thumbnails .slick-slide .image-box").attr('aria-current', 'false');
        jq(".slider-thumbnails .slick-slide .image-box").attr('aria-disabled', 'true');
        jq(".image-box", element).attr('aria-current','true');
        jq(".image-box", element).attr('aria-disabled','false');
        jq(".featured-slider").slick("slickGoTo", goToSingleSlide);
    }

    jq(".slider-thumbnails").on("click", ".slick-slide", function(event){
        event.preventDefault();
        goToSlide(this);
    });

    jq(".slider-thumbnails").on("keydown", ".slick-slide", function(event) {
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            goToSlide(this);
        }
    });

    jq(".slider-thumbnails .slick-slide").attr('tabindex', '0').attr('role', 'button').attr('aria-pressed', 'false');
}
    
//TIMELINE MENU
var timelineLinks = jq(".timeline-tabbed-content .nav-tabs .nav-link");
if (timelineLinks) {
    timelineLinks.on('click', function() {
        timelineLinks.removeClass("active");
        timelineLinks.closest(".nav-item").removeClass("child-active");
        jq(this).closest(".nav-item").addClass("child-active");
    });
}

var $status = jq('.current-slide-indicator');
if ($status) {
    var $slickElement = jq('.featured-employees-slider');

    $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
      //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
      var i = (currentSlide ? currentSlide : 0) + 1;
      $status.text(i + '/' + slick.slideCount);
    });
}

var $status2 = jq('.slide-count-indicator');
if ($status2) {
    var $slickElement2 = jq('.featured-slider');

    $slickElement2.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
      //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
      var i = (currentSlide ? currentSlide : 0) + 1;
      $status2.text(i + '/' + slick.slideCount);
    });
}
var $status3 = jq('.module-scholars-slider .slide-indicator');
if ($status3) {
    var $slickElement3 = jq('.scholar-slider');

    $slickElement3.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
      //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
      var i = (currentSlide ? currentSlide : 0) + 1;
      var s = (currentSlide ? currentSlide : 0);
      $status3.text(i + '/' + slick.slideCount);
      jq('.slick-slide[data-slick-index="'+s+'"]').focus();
    });
}

// trigger upload on space & enter (upload resume button)
jq('#resume-btn span[role=button]').bind('keypress keyup', function(e) {
  if (e.which === 32 || e.which === 13){
    e.preventDefault();
    jq('#resume').click();
  }    
});

jq('#clear-btn').click(function(e) {
    // Clear each input field in the form
    e.preventDefault();
    jq('#scholars-contact-form').find('input').each(function() {
        jq(this).val('');
    });
    jq('#scholars-contact-form').find('textarea').each(function() {
        jq(this).val('');
    });
});

jq(document).ready(function() {
  jq('.module-tabbed-content nav .nav-link').on('show.bs.tab', function(e) {
    // Remove 'active' class from all nav-item elements
    jq('.module-tabbed-content nav .nav-link').removeClass('active');
    jq('.module-tabbed-content nav .nav-link').attr('aria-selected', 'false');
  });
  jq('.module-tabbed-content nav .nav-link').on('shown.bs.tab', function(e) {
    // Remove 'active' class from all nav-item elements
    jq('.module-tabbed-content nav .nav-item').removeClass('active');
    jq('.module-tabbed-content nav .nav-item .nav-item-container').removeClass('active');
    
    // Add 'active' class to the parent nav-item of the currently active nav-link
    jq(e.target).closest('.nav-item').addClass('active');
    jq(e.target).closest('.nav-item-container').addClass('active');
  });
});
jq(document).ready(function() {
    jq('#slider-control-btn').click( function() {
      if (!jq(this).hasClass('paused')){
         jq('.images-slider').slick('slickPause');
         jq(this).attr('aria-pressed', 'true');
         jq(this).attr('aria-label', 'Play Image Slider');
         jq(this).addClass('paused');
      } else {
        jq('.images-slider').slick('slickPlay');
        jq(this).removeClass('paused');
        jq(this).attr('aria-pressed', 'false');
        jq(this).attr('aria-label', 'Pause Image Slider');
      }  
    });
});
jq(document).ready(function() {
    if (jq('#what-we-do').length > 0) {
        let urlParams = window.location.hash;
        
        let tablinks = jq('#what-we-do .nav-link');
        let tabpanels = jq('#what-we-do .tab-pane');
        
        if (urlParams && jq(urlParams).length > 0) {
            let button = jq('button[data-target="' + urlParams + '"]');
            let panel = jq(urlParams);
            tabpanels.removeClass('active');
            tabpanels.removeClass('show');
            tablinks.removeClass('active');
            tablinks.attr('aria-selected', 'false');
            tablinks.closest('.nav-item').removeClass('active');
            
            jq(urlParams).tab('show');
            button.attr('aria-selected', 'true');
            button.addClass('active');
            button.closest('.nav-item').addClass('active');
            
            setTimeout(function() {
                // Get the current scroll position of the panel
                let panelTop = panel.offset().top;
                
                // Calculate the scroll position with the offset
                let offset = 127;
                let scrollTo = panelTop - offset;
                
                // Scroll to the calculated position smoothly
                window.scrollTo({
                    top: scrollTo,
                    behavior: "smooth"
                });
            }, 250);
        }
    }
});
jq(document).ready(function() {
    let anchorLinks = jq(".sub-anchor-navigation ul li a[href^='#']").add(
        ".tertiary-nav-anchor-links > ul > li:not(.sidebar-title) a[href^='#']"
    );
    if (!anchorLinks.length) {
        return;
    }

    function getSections() {
        var sections = [];
        anchorLinks.each(function() {
            var target = jq(this).attr('href');
            if (target && target.startsWith('#')) {
                var section = jq(target);
                if (section.length) {
                    sections.push(section);
                }
            }
        });
        return sections;
    }

    var sections = getSections();
    if (!sections.length) {
        return;
    }

    jq(window).on('scroll', function() {
        var currentScroll = jq(this).scrollTop() + jq(window).height() / 2;

        sections.forEach(function(section) {
            var sectionTop = section.offset().top;
            var sectionBottom = sectionTop + section.outerHeight();

            if (currentScroll >= sectionTop && currentScroll < sectionBottom) {
                var currentId = section.attr('id');
                anchorLinks.parent().removeClass('active');
                anchorLinks.filter('[href="#' + currentId + '"]').parent().addClass('active');
            }
        });
    });
});
document.addEventListener("DOMContentLoaded", function () {
    // Adjust this value to set the scroll offset (in pixels)
    const offset = 127;

    document.querySelectorAll('a[href^="#"]:not([data-toggle="collapse"]):not([data-toggle="tab"]):not([class^="fancybox-"])').forEach(anchor => {
        anchor.addEventListener("click", function (e) {
            e.preventDefault();

            const targetId = this.getAttribute("href").substring(1);
            const targetElement = document.getElementById(targetId);

            if (targetElement) {
                const elementPosition = targetElement.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - offset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth"
                });
            }
        });
    });
});

    
// Search button click
jq('#search-button').click(function (e) {
    jq('.search, .search-form').toggleClass('active');
    if(jq(this).attr('aria-pressed') == 'false') {
        jq(this).attr('aria-pressed', 'true');  
    } else {
        jq(this).attr('aria-pressed', 'false');  
    }
    jq('.search input').focus();
});

jq(document).ready(function() {
  jq('.search').on('click', function() {
    if (jq(this).hasClass('active')) {
      jq('.main-menu').css('opacity', '0');
    } else {
      jq('.main-menu').css('opacity', '1');
    }
  });
});

jq(document).ready(function() {
    jq('.module-research-topics .nav-tabs .nav-link').on('click', function() {
        // Remove active classes from all nav-links and their tab panes
        jq('.module-research-topics .nav-tabs .nav-link').removeClass('active').attr('aria-selected', 'false');
        
        // Get the tab ID and update URL with query parameter
        const tabId = jq(this).data('target').replace('#tab', ''); // Remove '#tab' prefix
        window.location.href = `${window.location.pathname}?tab=${tabId}`;
    });
});

let visibleLinks = 4;
let totalLinks = jq('.module-research-topics .nav-tabs .nav-item').length;
let startIndex = 0;

function showLinks(start) {
    jq('.module-research-topics .nav-tabs .nav-item').hide();
    for (let i = 0; i < visibleLinks; i++) {
        jq('.module-research-topics .nav-tabs .nav-item').eq((start + i) % totalLinks).show();
    }
}

showLinks(startIndex);

jq('.module-research-topics .prev').on('click', function(e) {
    e.preventDefault();
    startIndex = (startIndex - 1 + totalLinks) % totalLinks;
    showLinks(startIndex);
});

jq('.module-research-topics .next').on('click', function(e) {
    e.preventDefault();
    startIndex = (startIndex + 1) % totalLinks;
    showLinks(startIndex);
});



// INTERACTIVE LOCATIONS MAP
jq(document).ready(function() {
    const infoDisplay = jq('#location-info-display');
    const infoTitle = jq('#info-title');
    const infoLocations = jq('#info-locations');
    
    function keepElementInView(element) {
        const rect = element.getBoundingClientRect();
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;
    
        let newLeft = rect.left;
        // Check if the element goes out of the right edge
        if (rect.right > viewportWidth) {
            newLeft -= rect.right - viewportWidth + 50;
        }  
        // Check if the element goes out of the left edge
        if (rect.right < 0) {
            newLeft = 10;
        }
        // Apply the new position
        element.style.left = `${newLeft}px`;
    }

    // Function to show the info box
    function showInfoBox(locationPoint) {
        const locationTitle = locationPoint.data('location');

        infoTitle.text(locationTitle);

        // Clear previous locations
        infoLocations.empty();

        // Add all addresses
        locationPoint.find('.location').each(function() {
            const location = jq(this);
            const addressHtml = `
                <div class="location-item">
                    <div class="location-title">${location.data('location')}</div>
                    <div class="location-details">
                        ${location.data('location-title') ? `<p class="mb-1">${location.data('location-title')}</p>` : ''}
                        ${location.data('location-address') ? `<p>${location.data('location-address')}</p>` : ''}
                        ${location.data('location-city') || location.data('location-state') || location.data('location-zip') ? `<p class="mb-1">${location.data('location-city')}, ${location.data('location-state')} ${location.data('location-zip')}</p>` : ''}
                        ${location.data('location-phone') ? `<p><strong>T:</strong> ${location.data('location-phone')}</p>` : ''}
                        ${location.data('location-email') ? `<p><strong>E:</strong>  <a href="mailto:${location.data('location-email')}">${location.data('location-email')}</a></p>` : ''}
                        ${location.data('location-contact') ? `<p><strong>Contact:</strong>  ${location.data('location-contact')}</p>` : ''}
                    </div>
                </div>
            `;
            infoLocations.append(addressHtml);
        });
        
        const pointOffset = locationPoint.offset();
        const svgOffset = locationPoint.closest('#locations-map-module').offset();
        
        if (locationPoint.hasClass('offset')) {
            infoDisplay.css({
                bottom: `0`,
                top: `unset`,
                left: `${pointOffset.left + locationPoint.width() - svgOffset.left + 10}px`
            }).addClass('active');
        } else {           
            infoDisplay.css({
                bottom: `unset`,
                top: `${pointOffset.top + locationPoint.height() - svgOffset.top + 10}px`,
                left: `${pointOffset.left + locationPoint.width() - svgOffset.left + 10}px`
            }).addClass('active');
        }
        
        keepElementInView(infoDisplay[0]);
    }

    // Mouseenter event on location point to show the info box
    jq('.location-point').on('mouseenter', function(event) {
        // Find all <g> elements with a matching data-name attribute
        jq('g[data-name]').each(function() {
            // Find inner <g> elements and set their opacity to 0
            jq(this).find('g').css('opacity', 1);
        });
        showInfoBox(jq(this));
        let locationName = jq(this).data('location');
        
        // Find all <g> elements with a matching data-name attribute
        jq('g[data-name="' + locationName + '"]').each(function() {
            // Find inner <g> elements and set their opacity to 0
            jq(this).find('g').css('opacity', 0);
        });
    });

    // Mouseenter event on info box to keep it visible
    infoDisplay.on('mouseenter', function() {
        infoDisplay.addClass('active');
    });
    
    // Close info box on clicking outside
    jq(document).on('click', function(event) {
        if (infoDisplay.hasClass('active')) {
            if (!infoDisplay.is(event.target) && !jq.contains(infoDisplay[0], event.target) && !jq(event.target).closest('.location-point').length) {
                infoDisplay.removeClass('active');
                // Find all <g> elements with a matching data-name attribute
                jq('g[data-name]').each(function() {
                    // Find inner <g> elements and set their opacity to 0
                    jq(this).find('g').css('opacity', 1);
                });
            }
        }
    });
});

jq(document).ready(function() {
    jq('#play-button').on('click', function() {
        jq('#video-thumbnail').hide();
        jq('#play-button').hide();
        jq('#vimeo-player').show();
        jq('#vimeo-player').removeClass('hide');
        var iframe = jq('#vimeo-player')[0];
        iframe.focus();
        var player = new Vimeo.Player(iframe);
        
        
        // Remove the "overlay" class from the parent .module-text-block--video
        jq(this).closest('.module-text-block--video').removeClass('overlay');

        player.play().catch(function(error) {
            console.error('Error playing the video:', error);
        });
    });
});

jq(document).ready(function() {
    var currentUrl = window.location.href;

    jq('#mobile-nav .main-menu li a').each(function() {
        var linkHref = jq(this).attr('href');

        if (currentUrl.includes(linkHref)) {
            jq(this).parent().addClass('active');
        }
    });
});

jq(document).ready(function() {
    jq('#skipLinks a').on('click', function(e) {
        // Prevent the default action
        e.preventDefault();
        
        // Get the target ID from the clicked anchor's href
        var targetId = jq(this).attr('href');
        
        // Find the first focusable element within the target section
        var targetElement = jq(targetId).find(':focusable').first();
        
        // If a focusable element is found, focus on it
        if (targetElement.length) {
            targetElement.focus();
        }
    });
});

// Extend jQuery to define the :focusable selector
jq.extend(jq.expr[':'], {
    focusable: function(el) {
        var element = jq(el);
        return element.is('a, button, :input, [tabindex]');
    }
});
jq(document).ready(function() {   
    setTimeout(function() {
        // Update .rc-pagination-prev
        jq('.rc-pagination-prev').each(function() {
            var titleText = jq(this).attr('title');
            if (titleText) {
                jq(this).removeAttr('title').attr('aria-label', titleText);
                jq(this).find('.rc-pagination-item-link').append('<span class="material-icons" aria-hidden="true">arrow_back</span>');
            }
        });

        // Update .rc-pagination-nexth
        jq('.rc-pagination-next').each(function() {
            var titleText = jq(this).attr('title');
            if (titleText) {
                jq(this).removeAttr('title').attr('aria-label', titleText);
                jq(this).find('.rc-pagination-item-link').append('<span class="material-icons" aria-hidden="true">arrow_forward</span>');
            }
        });
        
        // accessibility update to image thumbnails
        jq('.sui-result__image img').each(function() {
            jq(this).attr("aria-hidden","true");
        });
    }, 1500); // 1500 milliseconds delay
});

jq(document).ready(function() {

    // Define focusable elements
    var focusableSelector = 'a[href], a, area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]';

    jq('.tab-pane[id]').on('keydown', function(e) {
        // Check if Tab is pressed and it's the last focusable element
        jq('.tab-content , .tab-pane, .tab-pane a').attr('tabindex', '0');
        if (e.key === 'Tab' && !e.shiftKey) {
            var focusableElements = jq(this).find(focusableSelector).filter(':visible');
            var lastElement = focusableElements.last();
            if (jq(':focus').is(lastElement)) {
                e.preventDefault(); // Prevent default behavior
                // Focus is at the end, go back to the corresponding nav-item-container button
                var button = jq('.nav-item-container button[data-target="#' + jq(this).attr('id') + '"]');
                
                if (button.length) {
                    // Check if the focused element is the last button within .nav-item-container
                    var lastButtonInNavItem = jq('.nav-item-container button').last();
                    if (button.is(lastButtonInNavItem)) {
                        // Find the next .section element after the current .nav-item-container
                        var nextSection = jq(this).closest('.module').next('.module');       
                        if (nextSection.length) {
                            // Find the first focusable element in the next .section
                            var nextFocusable = nextSection.find(focusableSelector).filter(':visible').first();
                            if (nextFocusable.length) {
                                nextFocusable.focus();
                            }
                        }
                    } else {
                        var focusable = jq('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])').filter(':visible');
                        var index = focusable.index(button);
                        if (index > -1 && index < focusable.length - 1) {
                            focusable.eq(index + 1).focus();
                        }
                    }
                } 
            }
        }
        
        // Check if Shift + Tab is pressed and it's the first focusable element
        if (e.key === 'Tab' && e.shiftKey) {
            var focusableElements = jq(this).find(focusableSelector).filter(':visible');
            var firstElement = focusableElements.first();
            if (jq(':focus').is(firstElement)) {
                e.preventDefault(); // Prevent default behavior
                // Focus back to the corresponding nav-item-container button
                jq('.nav-item-container button[data-target="#' + jq(this).attr('id') + '"]').focus();
            }
        }
    });

    // Trigger click event when a button within .nav-item-container is focused
    jq('.nav-item-container button').on('focus', function() {
        jq(this).trigger('click'); // Trigger the click event
    });
    
        // Listen for keydown events on buttons within .nav-item-container
    jq('.nav-item-container button').on('keydown', function(e) {

        // Check if Enter is pressed
        if (e.key === 'Enter') {
            e.preventDefault(); // Prevent default behavior
            jq('.tab-content , .tab-pane, .tab-pane a').attr('tabindex', '0');
            var targetId = jq(this).data('target');
            if (targetId.length) {
                jq(targetId).focus(); // Focus on the target element
            }
        } else if (e.key === 'Tab' && !e.shiftKey) {
            // Check if the focused element is the last button within .nav-item-container
            var lastButtonInNavItem = jq('.nav-item-container button').last();
            if (jq(this).is(lastButtonInNavItem)) {
                jq('.tab-content , .tab-pane, .tab-pane a').attr('tabindex', '-1');
            } 
        }
    });
    function styleRichtextYoutubeOverlayLink(link, wrapper) {
        if (!link || !wrapper) {
            return;
        }

        wrapper.css('position', 'relative');
        link.css({
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'block',
            margin: 0,
            transform: 'none',
            'z-index': 2,
            'text-decoration': 'none'
        });

        link.find('.video-btn').css({
            'pointer-events': 'none'
        });
    }

    function convertYoutubeEmbedsToThumbnailLinks() {
        jq('iframe').each(function() {
            var iframe = jq(this);
            var src = iframe.attr('src') || '';
            var title = iframe.attr('title') || 'Watch video';
            var match = src.match(/(?:www\.)?youtube(?:-nocookie)?\.com\/embed\/([^?&]+)/);

            if (!match || !match[1]) {
                return;
            }

            var videoId = match[1];
            var watchUrl = 'https://youtube.com/watch?v=' + encodeURIComponent(videoId);
            var thumbnailCandidates = [
                'https://i.ytimg.com/vi/' + encodeURIComponent(videoId) + '/maxresdefault.jpg',
                'https://i.ytimg.com/vi/' + encodeURIComponent(videoId) + '/hqdefault.jpg',
                'https://i.ytimg.com/vi/' + encodeURIComponent(videoId) + '/mqdefault.jpg',
                'https://i.ytimg.com/vi/' + encodeURIComponent(videoId) + '/default.jpg'
            ];
            var thumbnailCandidateIndex = 0;
            var advanceThumbnail = function(imageElement) {
                thumbnailCandidateIndex += 1;
                if (thumbnailCandidateIndex < thumbnailCandidates.length) {
                    jq(imageElement).attr('src', thumbnailCandidates[thumbnailCandidateIndex]);
                }
            };
            var wrapper = jq('<div>', {
                class: 'video-embed-field-provider-youtube video-embed-field-responsive-video'
            }).css('position', 'relative');

            iframe.replaceWith(wrapper);

            wrapper.append(
                jq('<img>', {
                    src: thumbnailCandidates[thumbnailCandidateIndex],
                    alt: '',
                    'aria-hidden': 'true'
                }).on('error', function() {
                    advanceThumbnail(this);
                }).on('load', function() {
                    // YouTube often returns a tiny placeholder image for missing maxres/hq assets.
                    // If that happens, advance to the next candidate until one is valid.
                    var width = this.naturalWidth || 0;
                    var height = this.naturalHeight || 0;
                    var isTinyPlaceholder = (width <= 120 && height <= 90);
                    if (isTinyPlaceholder && thumbnailCandidateIndex < thumbnailCandidates.length - 1) {
                        advanceThumbnail(this);
                    }
                }).css({
                    display: 'block',
                    width: '100%',
                    height: 'auto'
                }),
                jq('<a>', {
                    href: watchUrl,
                    target: '_blank',
                    rel: 'noopener',
                    class: 'richtext-youtube-video-link',
                    'aria-label': title
                }).append(
                    jq('<span>', {
                        class: 'video-btn paused',
                        'aria-hidden': 'true'
                    }).css({
                        border: '1px solid #fff',
                        'box-sizing': 'border-box'
                    })
                )
            );

            styleRichtextYoutubeOverlayLink(wrapper.find('a').first(), wrapper);
        });

        // Also fix overlays previously rendered without full-size click area.
        jq('a.richtext-youtube-video-link, a.video-btn[href*="youtube.com/watch"]').each(function() {
            var existingOverlayLink = jq(this);
            var wrapper = existingOverlayLink.parent();
            if (wrapper.find('img[src*="ytimg.com/vi/"], img[src*="youtube.com/vi/"]').length) {
                styleRichtextYoutubeOverlayLink(existingOverlayLink, wrapper);
            }
        });
    }

    convertYoutubeEmbedsToThumbnailLinks();
    jq(window).on('load', convertYoutubeEmbedsToThumbnailLinks);
    jq(document).ajaxComplete(convertYoutubeEmbedsToThumbnailLinks);
    setTimeout(convertYoutubeEmbedsToThumbnailLinks, 750);

    if (jq('iframe')) {
        jq('iframe').each(function() {
            var video = jq(this);
            var vidSrc = "";
            vidSrc = video.attr('src');
            if (vidSrc) {
                if(vidSrc.length > 30){
                    if(vidSrc.substr(0,30)=="https://www.youtube.com/embed/"){
                        jq(this).wrap("<div class='youtube--container'></div>");
                    }
                }
            }
        });
    }
});

//Create a friendly multiple select choice from a native select that also complains with AaaS
if (jq('select.multiple-choices').length > 0) {
    jq('select.multiple-choices').each(function() {
        let attrName = jq(this).attr('name');
        let attrId = jq(this).attr('id');
        var isRequired = jq(this).hasClass('required') ? 'true' : '';
        let newSelect = '<div class="checkboxes-wrapper eq-select multiple" role="listbox" aria-label="Choose a value" aria-required="' + isRequired + '">';
        
       jq(this).children('option').each(function(counter) {
            let optionValue = jq(this).attr('value') ? jq(this).attr('value') : jq(this).text();
            newSelect += '<div class="checkbox-item">' +
                                '<input type="checkbox" name="' + attrName + '" id="' + attrId + counter + '" value="' + optionValue + '" class="required multicheckboxes" aria-label="' + optionValue  +  '" role="option" >' +
                                '<label class="no-asterisk" for="' + attrId + counter + '">' + optionValue + '</label>' +
                         '</div>'
        });
        newSelect += '</div>' 
        newSelect += '<div class="' + attrName + '-error-holder"> </div>'
        jq(this).after(newSelect)
        jq(this).css('display', 'none');
    })   
}